module.exports = __webpack_public_path__ + "static/media/xya_variegata.7c9aa288.jpg";